// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Divider,
//   Grid,
//   TextField,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
// } from "@mui/material";
// import patientService from "../../../Services/patientService";
// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import doctorService from "../../../Services/doctorService";
// import staffService from "../../../Services/staffService";
// import roleService from "../../../Services/roleService";

// const AddEditRoles = () => {
//   const [roleData, setRoleData] = useState({
//     role_name: "",
//     description: "",
//   });

//   const [doctorData, setDoctorData] = useState([]);

//   const { id } = useParams();
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setRoleData({ ...roleData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (id) {
//         await roleService.update(id, roleData);
//         toast.success("Doctor updated successfully!");
//       } else {
//         await roleService.create(roleData);
//         toast.success("Doctor added successfully!");
//       }
//       navigate("/hr/roles");
//     } catch (error) {
//       toast.error("Error saving patient.");
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="w-[90%] m-auto">
//       <h1 className="m-[30px] text-center font-[700] text-[20px]">
//         {id ? "Edit Role" : "Add Role"}
//       </h1>
//       <Divider />
//       <div>
//         <div className="mt-[20px] flex">
//           <div style={{ width: "50%" }}>
//             <TextField
//               label="Role"
//               variant="outlined"
//               fullWidth
//               name="role_name"
//               value={roleData.role_name}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <TextField
//               label="Job Description"
//               variant="outlined"
//               fullWidth
//               name="description"
//               value={roleData.description}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <Grid container style={{ justifyContent: "center", marginTop: "30px" }}>
//           <Button
//             variant="contained"
//             type="submit"
//             color="primary"
//             size="large"
//             className="!bg-[#007fff] !text-white"
//             style={{ borderRadius: "10px" }}
//           >
//             Save Roles and Continue
//           </Button>
//         </Grid>
//       </div>
//     </form>
//   );
// };

// export default AddEditRoles;

import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import roleService from "../../../Services/roleService";

const SectionLabel = ({ children }) => (
  <p className="text-[11px] uppercase tracking-widest font-[500] text-gray-400 mb-3 mt-6">
    {children}
  </p>
);

const InputField = ({ label, ...props }) => (
  <div className="flex flex-col gap-1">
    <label className="text-[12px] font-[500] text-gray-500">{label}</label>
    <input
      {...props}
      className="w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none hover:border-orange-200 focus:border-orange-200 focus:ring-2 focus:ring-orange-100"
    />
  </div>
);

const AddEditRoles = () => {
  const [roleData, setRoleData] = useState({
    role_name: "",
    description: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRoleData({ ...roleData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await roleService.update(id, roleData);
        toast.success("Role updated successfully!");
      } else {
        await roleService.create(roleData);
        toast.success("Role added successfully!");
      }
      navigate("/roles");
    } catch (error) {
      toast.error("Error saving role.");
    }
  };

  return (
    <div className="bg-gray-50 flex items-start justify-center py-6 sm:py-10 px-3 sm:px-4">

      <div className="w-full max-w-7xl">

        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">

          {/* ───── HEADER ───── */}
          <div className="bg-[#215187] px-5 sm:px-8 py-4 sm:py-5">
            <h1 className="text-white text-[16px] sm:text-[18px] font-[500]">
              {id ? "Edit Role" : "New Role"}
            </h1>
            <p className="text-gray-300 text-[12px] mt-0.5">
              {id
                ? "Update the role details below"
                : "Fill in the details below to create a new role"}
            </p>
          </div>

          {/* ───── FORM ───── */}
          <form
            onSubmit={handleSubmit}
            className="px-4 sm:px-6 md:px-8 py-5 sm:py-6"
          >

            <SectionLabel>Role Information</SectionLabel>

            {/* Responsive grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">

              <InputField
                label="Role Name"
                type="text"
                name="role_name"
                value={roleData.role_name}
                onChange={handleChange}
                required
                placeholder="Enter role name"
              />

              <InputField
                label="Job Description"
                type="text"
                name="description"
                value={roleData.description}
                onChange={handleChange}
                required
                placeholder="Enter job description"
              />

            </div>

            {/* ───── FOOTER ───── */}
            <div className="border-t border-gray-100 mt-7 sm:mt-8 pt-5 sm:pt-6 flex flex-col-reverse sm:flex-row items-center justify-between gap-3">

              <button
                type="button"
                onClick={() => navigate(-1)}
                className="w-full sm:w-auto text-[13px] text-gray-400 hover:text-gray-600 font-[500]"
              >
                ← Cancel
              </button>

              <button
                type="submit"
                className="w-full sm:w-auto bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] font-[500] px-6 py-2.5 rounded-lg"
              >
                {id ? "Update Role" : "Save & Continue →"}
              </button>

            </div>

          </form>

        </div>

        <p className="text-center text-[12px] text-gray-400 mt-4 px-2">
          {id
            ? "Changes will be saved immediately."
            : "Role will be available for assignment after saving."}
        </p>

      </div>
    </div>
  );
};

export default AddEditRoles;